import React, { useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import { useDispatch } from "react-redux";

// import Components
import BreadCrumb from "../../Components/Common/BreadCrumb";
import TileBoxs from "./TileBoxs";
import VisitorAnalytics from "./VisitorAnalytics";
import { fetchDashboardData } from "../../slices/analytics/thunk";

const Widgets = () => {
  const dispatch = useDispatch();

  // Fetch dashboard data once when component mounts
  useEffect(() => {
    dispatch(fetchDashboardData());
  }, [dispatch]);

  document.title = "Dashboard | " + process.env.REACT_APP_SITE_TITLE;
  
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Dashboard" pageTitle="Dashboard" />
        </Container>
      </div>
      <div className='table-container' style={{ marginTop: "0px" }}>
        <TileBoxs />
        <Container fluid className="mt-0 mb-10 p-0 dashbord">
          <Row>
            <Col xl={12}>
              <VisitorAnalytics />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Widgets;